import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "components/ui/button/Button";
import Form from "components/ui/form/Form";
import { password_input } from "utilities/formSchemas";
import PasswordChecker from "components/password-and-confirm-password/passwordcheckerversion2/PasswordCheckerVersion2";
import "./new-recover-password.scss";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RecoverPasswordData, usePostResetMutation } from "./recoverPasswordService";
import { ErrorType } from "utilities/error";
import { RESET_PASSWORD_ERROR, RESET_PASSWORD_INVALID_REQUEST } from "utilities/Constant";
import { LoadingOverlay } from "components/ui/loading-spinners";
import { setCredentials, setIsLogin, setUserId } from "features/authSlice";
import { useDispatch } from "react-redux";
import Footer from "components/footer/Footer";

const formSchema = z.object({
  password_input: password_input,
});

export default function NewRecoverPassword() {
  const {
    control,
    handleSubmit,
    formState: { dirtyFields },
  } = useForm({ resolver: zodResolver(formSchema) });
  const [isBtnDisabled, setIsBtnDisabled] = useState(true);
  const [error, setError] = useState(0);
  const [hasPwdError, setHasPwdError] = useState(false);
  const ispasswordFieldModified = (dirtyFields.password_input as boolean) || false;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const resetCode = searchParams.get("r");
  const emailAddress = searchParams.get("t");
  const dispatch = useDispatch();
  const [sendRequest, { data, isLoading, isSuccess }] = usePostResetMutation();
  const onSubmit = (data: RecoverPasswordData) => {
    if (!hasPwdError) {
      sendRequest(data).unwrap().catch((error: ErrorType) => {
        if (error.status == 400 || error.status == 404 || error.status == 500) {
          navigate("/", { replace: true })
        } else {
          setError(error.status);
        }
      })
    }
  };

  useEffect(() => {
    if (isSuccess && data) {
      dispatch(setUserId(data.id));
      dispatch(setIsLogin(true));
      dispatch(
        setCredentials({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
          name: data.name,
          id: data.id,
          version: data.version,
          status: data.status,
          isRedesignAnnouncementVisible: data.isRedesignAnnouncementVisible
        })
      );
      navigate("/my-loans", { replace: true });
    }
  }, [isSuccess, data, dispatch, navigate]);

  if (isLoading) return <LoadingOverlay text="Loading..." />;

  return (
    <>
      <div className="new-recover-password">
        <div className="new-recover-password--header">
          <span className="new-recover-password--header__text1">Reset password</span>
          <p className="new-recover-password--header__text2">This will update your previous password</p>
          {error == 409 && <p className="recover-password-header_error">{RESET_PASSWORD_ERROR}</p>}
          {error == 406 && <p className="recover-password-header_error">{RESET_PASSWORD_INVALID_REQUEST}</p>}
        </div>{" "}
        <div className="new-recover-password__form">
          <Form onSubmit={handleSubmit((data) => {
            onSubmit({
              emailAddress: emailAddress!,
              newPassword: data.password_input as string,
              recoveryCode: resetCode!
            });
          })}
          >
            <div className="row--item">
              <Controller
                name="password_input"
                control={control}
                render={({ field: { onChange } }) => (
                  <PasswordChecker
                    onChange={onChange}
                    checkErrors={ispasswordFieldModified}
                    createLabel="Password"
                    setHasPasswordError={setHasPwdError}
                    setBtnVisible={setIsBtnDisabled}
                    createPasswordPlaceholderName="New password"
                  />
                )}
              />
            </div>
            <Button title="Continue" disabled={isBtnDisabled} />
          </Form>
        </div>
      </div>
      <div className="forgot-password-footer">
        <Footer />
      </div>
    </>
  );
}
